import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a35a5f1"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex justify-between border-b py-1 text-xs" };
const _hoisted_2 = { class: "flex gap-2" };
const _hoisted_3 = { class: "flex items-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_fileIcon = _resolveComponent("fileIcon");
    const _component_UITextXsMedium = _resolveComponent("UITextXsMedium");
    const _component_UITooltip = _resolveComponent("UITooltip");
    const _component_UISpin = _resolveComponent("UISpin");
    const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_UITooltip, null, {
            trigger: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_fileIcon, { file: _ctx.file }, null, 8, ["file"]),
                    _createVNode(_component_UITextXsMedium, { class: "max-w-sm truncate" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.truncate(_ctx.file.name, { length: 35 })), 1)
                        ]),
                        _: 1
                    })
                ])
            ]),
            default: _withCtx(() => [
                _createVNode(_component_UITextXsMedium, { class: "max-w-sm truncate" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.file.name), 1)
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
            (_ctx.file.url)
                ? (_openBlock(), _createBlock(_component_UITextXsMedium, {
                    key: 0,
                    class: "cursor-pointer mr-2 copy-uploaded-link",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.copyLink(_ctx.file.url)))
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.tooltipText), 1)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true),
            (!_ctx.file.uploaded)
                ? (_openBlock(), _createBlock(_component_UISpin, {
                    key: 1,
                    size: 14
                }))
                : (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                    key: 2,
                    class: "w-4 h-4 text-apple-500"
                }))
        ])
    ]));
}
